import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Icon } from '../../../components/Sustainability/HotelBadge/components/Icon.js';
import { LabelXSmall, Tooltip } from '../../../primitives/index.js';
export const SustainabilityHotelBadge = /*#__PURE__*/_styled(({
  size = 'medium',
  certifyingAuthority,
  ...restProps
}) => {
  const {
    t
  } = useTranslation('sustainability');
  return _jsx(Tooltip, {
    tooltipElement: "IconSustainability",
    tooltipText: t('hotelBadge.description', {
      certificate: certifyingAuthority ? `(${certifyingAuthority})` : ''
    }),
    placement: "top",
    content: _jsx(LabelXSmall, {
      children: t('hotelBadge.description', {
        certificate: certifyingAuthority ? `(${certifyingAuthority})` : ''
      })
    }),
    "data-interaction-trigger": true,
    children: _jsx(Icon, {
      ...restProps,
      size: size
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "elc8q8l0"
} : {
  target: "elc8q8l0",
  label: "SustainabilityHotelBadge"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNHIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IHVzZVRyYW5zbGF0aW9uIH0gZnJvbSAnbmV4dC1pMThuZXh0JztcbmltcG9ydCB7IEljb24gfSBmcm9tICcuLi8uLi8uLi9jb21wb25lbnRzL1N1c3RhaW5hYmlsaXR5L0hvdGVsQmFkZ2UvY29tcG9uZW50cy9JY29uLmpzJztcbmltcG9ydCB7IExhYmVsWFNtYWxsLCBUb29sdGlwIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9pbmRleC5qcyc7XG5leHBvcnQgY29uc3QgU3VzdGFpbmFiaWxpdHlIb3RlbEJhZGdlID0gc3R5bGVkKCh7IHNpemUgPSAnbWVkaXVtJywgY2VydGlmeWluZ0F1dGhvcml0eSwgLi4ucmVzdFByb3BzIH0pID0+IHtcbiAgICBjb25zdCB7IHQgfSA9IHVzZVRyYW5zbGF0aW9uKCdzdXN0YWluYWJpbGl0eScpO1xuICAgIHJldHVybiAoX2pzeChUb29sdGlwLCB7IHRvb2x0aXBFbGVtZW50OiBcIkljb25TdXN0YWluYWJpbGl0eVwiLCB0b29sdGlwVGV4dDogdCgnaG90ZWxCYWRnZS5kZXNjcmlwdGlvbicsIHtcbiAgICAgICAgICAgIGNlcnRpZmljYXRlOiBjZXJ0aWZ5aW5nQXV0aG9yaXR5ID8gYCgke2NlcnRpZnlpbmdBdXRob3JpdHl9KWAgOiAnJyxcbiAgICAgICAgfSksIHBsYWNlbWVudDogXCJ0b3BcIiwgY29udGVudDogX2pzeChMYWJlbFhTbWFsbCwgeyBjaGlsZHJlbjogdCgnaG90ZWxCYWRnZS5kZXNjcmlwdGlvbicsIHtcbiAgICAgICAgICAgICAgICBjZXJ0aWZpY2F0ZTogY2VydGlmeWluZ0F1dGhvcml0eVxuICAgICAgICAgICAgICAgICAgICA/IGAoJHtjZXJ0aWZ5aW5nQXV0aG9yaXR5fSlgXG4gICAgICAgICAgICAgICAgICAgIDogJycsXG4gICAgICAgICAgICB9KSB9KSwgXCJkYXRhLWludGVyYWN0aW9uLXRyaWdnZXJcIjogdHJ1ZSwgY2hpbGRyZW46IF9qc3goSWNvbiwgeyAuLi5yZXN0UHJvcHMsIHNpemU6IHNpemUgfSkgfSkpO1xufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1pbmRleC5qcy5tYXAiXX0= */");